<ng-container *ngIf="serviceList">
  <ng-container *ngFor="let item of serviceList">
    <section
      class="google-workspace-banner"
      [innerHTML]="translate.currentLang === 'th' ? item.data.content.th : item.data.content.en"
    ></section>
  </ng-container>
</ng-container>
